import axios from "axios";
import store from "@/store";

axios.defaults.baseURL = process.env.VUE_APP_BASE_API_URL;

// TODO: Prevent users from running any requests (except GET) when subscription expires.

axios.interceptors.request.use(
    config => {
        const token = store.state.User.token || Cookies.get("token");
        const userId = store.state.User.data._id || 0;
        if (token) {
            store.dispatch("User/setToken", token);
            config.headers = {
                ...config.headers,
                token,
                user_id: userId,
                device: "web",
                territory: "US"
            }
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    },
);

axios.interceptors.response.use(response => {
    // Do something with response data
    return response;
}, error => {
    // Only report errors on production
    if (process.env.NODE_ENV !== "development") {
        Sentry.captureException(error);
    }
    // Do something with response error
    return Promise.reject(error);
});

window.axios = axios;

export default axios;
